import { inject, Injectable } from '@angular/core';
import { Router, UrlTree } from '@angular/router';

import { Capacitor } from '@capacitor/core';
import { Platform } from '@ionic/angular';
import { select, Store } from '@ngrx/store';

import { isEmpty } from 'lodash-es';
import { from, map, Observable, tap } from 'rxjs';

import { PrimarySubscriptionPlanAccessAliasEnum } from '../../enums/monetization';
import * as fromOrganizationSelectors from '../../store/selectors/organization.selectors';
import { MonetizationService } from '../services/monetization.service';

@Injectable({
  providedIn: 'root'
})
export class ChangeIconGuard {
  private monetizationService = inject(MonetizationService);
  private platform = inject(Platform);
  private router = inject(Router);
  private store = inject(Store);

  isChangeIconAvailable = Capacitor.isNativePlatform() && this.platform.is('ios');
  constructor() {
    this.store.pipe(select(fromOrganizationSelectors.selectAlternateAppIconName)).subscribe((alternateAppIconName) => {
      this.isChangeIconAvailable =
        Capacitor.isNativePlatform() && this.platform.is('ios') && !isEmpty(alternateAppIconName);
    });
  }
  canActivate(): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    return from(
      this.monetizationService.accessFeature([PrimarySubscriptionPlanAccessAliasEnum.A], {
        preventPaywall: true
      })
    ).pipe(
      tap(async (hasAccess) => {
        if (!hasAccess && !this.isChangeIconAvailable) {
          await this.monetizationService.showPrimarySubscriptionPlanPaywall({ onboardingPaywall: true });
        }
      }),
      map(() => (this.isChangeIconAvailable ? true : this.router.createUrlTree(['/'])))
    );
  }
}
